import useApi from '../../common/hooks/useApi'
import useSWR from 'swr'
import { type SupplierType } from '@amici/myamici-api-client'

interface UseSupplierTypesHook {
  supplierTypes: SupplierType[] | undefined
  isLoading: boolean
  hasData: boolean
  loadingError: any
}

function useSupplierTypes (): UseSupplierTypesHook {
  const { metadataApi, fetcherWithoutParams } = useApi()

  const {
    data,
    isLoading,
    error: loadingError
  } = useSWR(
    'allSupplierTypes',
    async () =>
      await fetcherWithoutParams(metadataApi.getAllActiveSupplierTypes())
  )

  const hasData = Array.isArray(data) && data.length > 0

  return {
    supplierTypes: data,
    isLoading,
    hasData,
    loadingError
  }
}

export default useSupplierTypes
